import { useContext } from 'react';
import { CopilotChannelContext } from '../channel/CopilotChannelContext';
export const useIsCopilotWidgetActive = () => {
  const {
    channelState
  } = useContext(CopilotChannelContext);
  return channelState.isWidgetActive;
};